var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('app-text',{attrs:{"class-name":"font-weight-bold"}},[_vm._v(" No access ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }